import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { DropdownComponent } from './dropdown.component';

@NgModule({
    imports: [CommonModule, FormsModule, TranslateModule, NgSelectModule, PopoverModule],
    exports: [DropdownComponent],
    declarations: [DropdownComponent]
})
export class DropdownModule {}
